import * as React from 'react';
import { UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface INewQuestionContent {
  name: React.ReactElement<any>;
  question: React.ReactElement<any>;
  anonymous: React.ReactElement<any>;
}
export const NewQuestionContent: React.FC<INewQuestionContent> = ({ name, question, anonymous }) => {
  return (
    <div className={styles['content']}>
      <div className={styles['section']}>
        <div className={styles['title']}>
          <UIHeading4>Расскажите о себе</UIHeading4>
        </div>
        <div className={styles['subtitle']}>
          <UIText2>Имя</UIText2>
        </div>
        <div className={styles['name']}>{name}</div>
      </div>
      <div className={styles['section']}>
        <div className={styles['title']}>
          <UIHeading4>Задайте вопрос</UIHeading4>
        </div>
        {question}
      </div>
      <div className={styles['section']}>{anonymous}</div>
    </div>
  );
};
